import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, Divider, Drawer, FormControl, FormLabel, Grid, Input, ModalClose, Option, Select } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { Building } from "../Pages/BuildingList";

interface UsersDialogProps {
	usersId: string;
	close: Function;
}

interface UserRecord {
	buildings: string;
	email_address: string;
	first_name: string;
	last_name: string;
	role: string | null;
	title: string;
	users_id: string;
	is_active: boolean;
	is_packing_lists: boolean;
}
export default function UsersDialog(props: UsersDialogProps) {
	const [user, setUser] = React.useState<UserRecord>();
	const [open, setOpen] = React.useState(false);
	const [buildings, setBuildings] = React.useState([] as Array<Building>);
	const [bldFilter, setBldFilter] = React.useState("");

	React.useEffect(() => {
		if (!Util.isNullOrEmpty(props.usersId)) {
			fetch("User/GetUserInfo", {
				method: "Post",
				cache: "no-cache",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ usersId: props.usersId }),
			})
				.then((x) => x.json())
				.then((x) => {
					const rec = x as UserRecord;
					setUser({ ...rec, is_packing_lists: Boolean(rec.is_packing_lists) });
					setOpen(true);
				});
		} else {
			setUser({ is_packing_lists: false } as UserRecord);
			setOpen(true);
		}
		getBuildings();
	}, []);

	const getBuildings = () => {
		fetch("Building")
			.then((x) => x.json())
			.then((x) => {
				setBuildings(
					x
						.sort((a: any, b: any) => a.building_name.localeCompare(b.building_name))
						.map((y: any) => {
							return { Name: y.building_name, ID: y.buildings_id } as Building;
						})
				);
			});
	};

	const save = () => {
		if (!user) return;
		if (Util.isNullOrEmpty(user.email_address)) {
			alert("Email address is required.");
			return;
		}
		if (Util.isNullOrEmpty(user.last_name)) {
			alert("Last name is required.");
			return;
		}
		if (Util.isNullOrEmpty(user.first_name)) {
			alert("First name is required.");
			return;
		}
		fetch("User/SaveUserInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(JSON.stringify(user)),
		}).then((x) => props.close());
	};

	const close = () => {
		props.close();
	};

	const sizes = {
		sm: 12,
		md: 6,
	};

	const threeSizes = {
		sm: 12,
		md: 6,
		lg: 4,
	};

	const sendReset = () => {
		if (!window.confirm("Are you sure you want to resend?")) return;
		fetch("User/SendPasswordReset", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(user?.email_address),
		});
	};

	const selectedBuildings = user && !Util.isNullOrEmpty(user.buildings) ? user?.buildings.split(",").map((x) => x.trim().toUpperCase()) : [];
	return (
		<>
			<Drawer anchor="right" open={open} size="lg">
				<ModalClose onClick={close} />
				<DialogTitle>User Form</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					{user && (
						<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
							<Grid xs={12}>
								<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>User Information</FormLabel>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>First Name</FormLabel>
									<Input
										onChange={(event) => {
											setUser({ ...user, first_name: event.target.value });
										}}
										value={user.first_name}
										name="first_name"></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Last Name</FormLabel>
									<Input
										onChange={(event) => {
											setUser({ ...user, last_name: event.target.value });
										}}
										value={user.last_name}
										name="last_name"></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Email</FormLabel>
									<Input
										onChange={(event) => {
											setUser({ ...user, email_address: event.target.value });
										}}
										value={user.email_address}
										name=""></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Title</FormLabel>
									<Input
										onChange={(event) => {
											setUser({ ...user, title: event.target.value });
										}}
										value={user.title}
										name="title"></Input>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Is active?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setUser({ ...user, is_active: event.target.checked });
										}}
										checked={user.is_active}
										name="Is active?"></Checkbox>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Packing lists?</FormLabel>
									<Checkbox
										onChange={(event) => {
											setUser({ ...user, is_packing_lists: event.target.checked });
										}}
										checked={Boolean(user.is_packing_lists)}
										name="is_packing_lists"
									/>
								</FormControl>
							</Grid>
							<Grid {...sizes}>
								<FormControl>
									<FormLabel>Role</FormLabel>
									<Select onChange={(event, value) => setUser({ ...user, role: value })} value={user.role}>
										<Option value="Admin">Admin</Option>
										<Option value="Manager">Manager</Option>
										<Option value="Client">Client</Option>
										<Option value="Ticketing">Ticketing</Option>
									</Select>
								</FormControl>
							</Grid>
							<Grid xs={12}>
								<FormControl>
									<FormLabel>Buildings</FormLabel>
									<Grid {...sizes}>
										<FormControl>
											<Input value={bldFilter} onChange={(event) => setBldFilter(event.target.value.toLowerCase())} placeholder="Search Buildings" />
										</FormControl>
									</Grid>
									<Box sx={{ maxHeight: "300px", overflowY: "auto", overflowX: "hidden" }}>
										{buildings
											.filter((x) => Util.isNullOrEmpty(bldFilter) || x.Name.toLowerCase().includes(bldFilter.trim()))
											.map((x) => {
												return (
													<FormControl sx={{ py: 1 }}>
														<Checkbox
															size="sm"
															onChange={(event) => {
																if (event.target.checked) {
																	selectedBuildings.push(x.ID.toUpperCase());
																	setUser({ ...user, buildings: selectedBuildings.join(", ") });
																} else {
																	selectedBuildings.splice(selectedBuildings.indexOf(x.ID.toUpperCase()), 1);
																	setUser({ ...user, buildings: selectedBuildings.join(", ") });
																}
															}}
															checked={selectedBuildings.includes(x.ID.toUpperCase())}
															label={x.Name}
														/>
													</FormControl>
												);
											})}
									</Box>
								</FormControl>
							</Grid>
						</Grid>
					)}
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						{!Util.isNullOrEmpty(props.usersId) && (
							<Button size="lg" color="primary" onClick={sendReset} sx={{ mx: 1 }}>
								Send Password Reset
							</Button>
						)}
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
						<Button size="lg" color="primary" onClick={close} sx={{ mx: 1 }}>
							Close
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
